import styled from 'styled-components';

import { getSpacing } from 'stylesheetB2b';

export const SessionEndLogoButtonContainer = styled.div`
  background: none;
  border: none;
  height: ${getSpacing(26)};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
`;

export const LogoButton = styled.button`
  background: none;
  border: none;
`;
LogoButton.displayName = 'Logo button';
